module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/square_2x.c801635.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/square_2x.png
// module id = rYja
// module chunks = 41